const category = {
  digital: {
    title: "数字藏品",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "领略独一无二的数字藏品",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/digital/purchase?navhide=1&lotteryId={id}",
  },
  collection: {
    title: "数字周边",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "找寻属于你的数字周边",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/v2/card/collection?hybrid_set_header=2&act_id={id}",
  },
  suit: {
    title: "个性装扮",
    iconURL: require("./assets/pinkDress.svg"),
    subTitle: "找寻属于你的个性装扮",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/suit/detail?navhide=1&id={id}",
  },
  dlc: {
    title: "数字周边",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "找寻属于你的数字周边",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/digital-card/home?navhide=1&hybrid_set_header=2&-Abrowser=live&act_id={id}",
  },
  "garb-summer": {
    title: "装扮赏·仲夏幻想",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://ff-uat-activity.bilibili.com/preview/redpack/activity-M0LBEFrfUD.html?navhide=1",
  },
  "garb-winter-2023": {
    title: "装扮赏·琉晶之礼",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-C32RAXikal.html?navhide=1&act_id={id}",
  },
  wish: {
    title: "装扮祈愿会",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-3cc5x8HFHJ.html?navhide=1&hybrid_set_header=2&-Abrowser=live&act_id={id}",
  },
  "gift-202401": {
    title: "龙年金运，点卡成金",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://m.bilibili.com/doria/card-exchange.html?exchange_act_id={id}",
  },
  "gift-package-202402": {
    title: "新春豪礼",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-rzNlwXhoos.html?navhide=1&act_id={id}",
  },
  "gift-202405": {
    title: "礼包活动",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-PpTLCPHRqO.html?navhide=1",
  },
  "garb-common-wish-2024": {
    title: "装扮祈愿会",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-0LPHv03rNO.html?navhide=1&_no_={id}",
  },
  "garb-reward-202406": {
    title: "装扮赏·星时影迹",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-eOz6tP3zgP.html?navhide=1&act_id={id}",
  },
  "rank-act": {
    title: "收藏集榜单活动",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb-rank-list.html?act_id={id}",
  },
  "gift-202407": {
    title: "箱中灵羽",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-e5RONdFsV5.html?navhide=1",
  },
  "gift-202410": {
    title: "幻影新生",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-WqLvIDsEaj.html?navhide=1",
  },
  "out-avatar-202409": {
    title: "集齐全图鉴，赢限定出框",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-7B5cb50pOi.html?navhide=1",
  },
  "gift-202411": {
    title: "暮色战姬",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-qYXsg3SiVs.html?navhide=1",
  },
  "garb-5th-main": {
    title: "绘梦记",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-Kd0pTqZEno.html?navhide=1&f_source=plat&from=ad.task",
  },
  "garb-5th-report": {
    title: "绘梦录",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-T4bmPeNPgK.html?navhide=1&f_source=plat&from=ad.task",
  },
  "garb-5th-jigsaw": {
    title: "森之绮境",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-w5TcB7eaWh.html?navhide=1&f_source=plat&from=ad.task",
  },
  "garb-5th-treasure": {
    title: "拾光藏宝",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-BQdBI7u3ir.html?navhide=1&f_source=plat&from=ad.task",
  },
  "spring-202501": {
    title: "蛇来运转",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-VevSUw04Ue.html?navhide=1",
  },
  "out-avatar-202503": {
    title: "集齐全图鉴，赢限定出框",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-tSpNtU5sLl.html?navhide=1",
  },
  "gift-202505": {
    title: "圣羽裁决",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-LmAT7gEHgb.html?navhide=1",
  },
  "gift-202503": {
    title: "祈梦之境",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-2JbHAg1O2B.html?navhide=1",
  },
};
export { category };
